import defaultLayout from './defaultLayout'
import { LayoutDefinition, LayoutEntry } from './layout'
import { PANELS, isPanelId } from './registry'
import { isPanelSpan } from './spans'

// The logger and the log became one panel; a stored layout keeps the place of whichever it had.
const RENAMED_PANELS: Record<string, string> = { eventLogger: 'participantHistory', eventHistory: 'participantHistory' }

// The service validates the stored *shape*; what the ids mean is decided here, so a panel rename is
// not a coordinated deploy. A newly shipped panel is never appended to a stored layout (ADR-020).
export const reconcileLayout = (stored: unknown, fallback: LayoutDefinition = defaultLayout): LayoutDefinition => {
  if (!Array.isArray(stored)) {
    return fallback
  }

  const seen = new Set<string>()
  const panels: LayoutEntry[] = []

  stored.forEach((entry) => {
    if (typeof entry !== 'object' || entry === null) {
      return
    }

    const { panel: storedPanel, span, config } = entry as { panel?: unknown; span?: unknown; config?: unknown }
    const panel = typeof storedPanel === 'string' ? RENAMED_PANELS[storedPanel] ?? storedPanel : storedPanel

    if (!isPanelId(panel) || seen.has(panel)) {
      return
    }

    // Guarantees only *some* plain object — validity is the reading panel's job.
    const safeConfig =
      typeof config === 'object' && config !== null && !Array.isArray(config)
        ? (config as Record<string, unknown>)
        : undefined

    seen.add(panel)
    panels.push({
      panel,
      span: isPanelSpan(span) ? span : PANELS[panel].defaultSpan,
      ...(safeConfig ? { config: safeConfig } : {}),
    })
  })

  return panels.length > 0 ? { panels } : fallback
}
